import { ActionButton } from "@/shared/ui";

export const AdminPage: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <ActionButton label={"Пользователи"} to="/admin/users" />
      <ActionButton label={"Чаты"} to="/admin/chats" />
      <ActionButton label={"Дашборд"} to="/admin/dashboard" />
      <ActionButton label={"🔔 Push-уведомления"} to="/admin/notifications" />
    </div>
  );
};
